import { useState } from "react";
import { Bell } from "lucide-react";
import { loadNotifPrefs, saveNotifPrefs } from "@/lib/notifPrefs";
import { toast } from "sonner";

export function NotificationPrefs() {
  const [prefs, setPrefs] = useState(loadNotifPrefs());

  const toggle = (k) => {
    const next = { ...prefs, [k]: !prefs[k] };
    setPrefs(next);
    saveNotifPrefs(next);
    toast.success("Preferences saved");
  };

  return (
    <div data-testid="notif-prefs" className="border hairline p-5">
      <div className="flex items-center gap-2">
        <Bell size={16} className="text-[#FF3B30]" />
        <div className="font-display text-lg font-bold">Notification preferences</div>
      </div>
      <p className="text-neutral-500 text-xs mt-1">Choose which events pop a browser notification.</p>
      <div className="mt-4 flex flex-wrap gap-4">
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            data-testid="pref-hires"
            checked={prefs.hires}
            onChange={() => toggle("hires")}
            className="accent-[#FF3B30] w-4 h-4"
          />
          <span className="text-sm">New hire requests</span>
        </label>
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            data-testid="pref-bookings"
            checked={prefs.bookings}
            onChange={() => toggle("bookings")}
            className="accent-[#FF3B30] w-4 h-4"
          />
          <span className="text-sm">Booking status changes</span>
        </label>
      </div>
    </div>
  );
}
